import { render, staticRenderFns } from "./DrawerUpcomingFeatures.vue?vue&type=template&id=d10ca774&scoped=true&"
import script from "./DrawerUpcomingFeatures.vue?vue&type=script&lang=js&"
export * from "./DrawerUpcomingFeatures.vue?vue&type=script&lang=js&"
import style0 from "./DrawerUpcomingFeatures.vue?vue&type=style&index=0&id=d10ca774&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d10ca774",
  null
  
)

export default component.exports